import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryCards() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-500/10 border border-accent-500/20 rounded-full text-accent-400 text-xs font-medium mb-4">
            分类浏览
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-50">
            按类别<strong className="text-accent-400">追踪爆料</strong>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative h-80 rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={`${cat.name}分类`}
                title={`黑料718${cat.name}`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-900/90 via-background-900/40 to-background-900/10"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500/20 flex items-center justify-center mb-4 group-hover:bg-primary-500/40 transition-colors">
                  <i className={`${cat.icon} text-2xl text-primary-400 w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-foreground-50 text-xl font-bold mb-2">{cat.name}</h3>
                <p className="text-foreground-400 text-sm leading-relaxed max-w-xs">{cat.description}</p>
                <span className="mt-4 text-primary-400 text-xs font-medium flex items-center space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>{cat.count}条爆料</span>
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}